import React from 'react'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import { Field, LabeledSelect, LocalizedText } from 'labguard-cdk'
import { DatabaseIcon } from 'src/components/common'

const query = gql`
  query databaseSelector {
    restoredDatabases {
      id
      name
    }
  }
`

function DatabaseSelector() {
  const { data: { restoredDatabases = [] } = {} } = useQuery(query)

  return restoredDatabases.length ? (
    <Field
      name="database"
      component={LabeledSelect}
      icon={DatabaseIcon}
      topLabel={<LocalizedText id="WEB_LOGIN_DATABASE" />}
    >
      <LocalizedText id="WEB_DEFAULT_DATABASE">{label => <option value="">{label}</option>}</LocalizedText>
      {restoredDatabases.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      ))}
    </Field>
  ) : (
    ''
  )
}

export default DatabaseSelector
